"use strict";
import styled from "lib/styled-components";
import { Body } from "pages/App/Body";
import { Header } from "pages/App/Header";
import { GRID_AREAS } from "pages/App/utils/shared";
import Aurora from "pages/Landing/components/Aurora/Aurora";
import { useLocation } from "react-router-dom";
import { breakpoints } from "ui/src/theme";
const AppContainer = styled.div`
  min-height: 100vh;
  max-width: 100vw;

  // grid container settings
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto 1fr;
  grid-template-areas: '${GRID_AREAS.HEADER}' '${GRID_AREAS.MAIN}' '${GRID_AREAS.MOBILE_BOTTOM_BAR}';
`;
const AuroraWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 0;
`;
const AppBody = styled.div`
  grid-area: ${GRID_AREAS.MAIN};
  width: 100vw;
  min-height: 100%;
  max-width: ${({ theme }) => `${theme.maxWidth}px`};
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  flex: 1;
  position: relative;
  margin: auto;

  @media screen and (max-width: ${breakpoints.md}px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`;
export function AppLayout() {
  const location = useLocation();
  const isLandingPage = location.pathname === "/";
  return <>
      <div
    style={{
      position: "absolute",
      inset: 0,
      zIndex: 0,
      width: "100vw",
      height: "100vh",
      pointerEvents: "none"
    }}
  >
          <Aurora colorStops={["#3A29FF", "#7ca7ff", "#4c3ff7"]} blend={0.5} amplitude={1} speed={0.5} />
        </div>
      <AppContainer>
        <Header />
        <AppBody>
          <Body />
        </AppBody>
      </AppContainer>
    </>;
}
